import { Outlet } from "react-router-dom";

const UserPrivateRoute = () => {
	return <Outlet />;
};

export default UserPrivateRoute;
